import {useTranslation} from "../i18n";
import "../finance/financeOperations.css";

export const MutationResultBanner = ({result, onRetry}) => {
    const {t} = useTranslation();
    if (!result) return null;
    const kind = result.kind === "success" || result.kind === "uncertain" ? result.kind : "error";
    const title = t(`common.mutation.${kind}`);

    return (
        <section className={`finance-mutation-banner finance-mutation-banner-${kind}`} role={kind === "success" ? "status" : "alert"}>
            <div>
                <strong>{title}</strong>
                {result.message ? <p>{result.message}</p> : null}
                {result.requestId ? (
                    <small>{t("common.mutation.requestId", {requestId: result.requestId})}</small>
                ) : null}
            </div>
            {typeof onRetry === "function" ? (
                <button type="button" className="admin-button admin-button-secondary" onClick={onRetry}>
                    {t("common.mutation.retry")}
                </button>
            ) : null}
        </section>
    );
};
